<template>

        <div class="tip-wrapper">

            <h3>Enter Tip</h3>
            <div class="tip-button-wrap">

                <button type="button" class="button btn-white" @click=" setTip( 0.00 ) ">None</button>
                <button type="button" class="button btn-white" @click=" setTip( 0.15 ) ">15%</button>
                <button type="button" class="button btn-white" @click=" setTip( 0.20 ) ">20%</button>
                <button type="button" class="button btn-white" @click=" setTip( 0.25 ) ">25%</button>
            </div>
            <h4>Custom Amount</h4>
            <input type="number" min="0" :value=" orderTip " class="tip-input" @blur=" updateTip( $event.target.value ) "/>
        </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex';

    export default {

        name: 'tip-widget',
        methods: {

            ...mapActions({

                setTip : 'orderTab/setTip'
            }),
            updateTip( value ){

                this.$store.commit( 'orderTab/updateTip', value );
            }
        },
        computed: {

            ...mapGetters({

                orderTip : 'orderTab/orderTip'
            })
        },
        created(){

            this.setTip( 0.20 );
        }
    }
</script>

<style scoped>

    .tip-wrapper{

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        text-align: center;
        margin: 0;
    }
    .tip-wrapper > h4 {

        margin: 0;
    }
    .tip-button-wrap{

        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        box-sizing: border-box;
        max-width: 100%;
        overflow: hidden;
    }
    .tip-input {

        text-align: center;
        width: 95%;
        box-sizing: border-box;
        margin: 0px auto 10px;
        height: 45px; /* Specified height */
        font-size: 20px;
        background: #efefef; /* Grey background */
        outline: none; /* Remove outline */
        border: 1px solid #ccc;
        border-radius: 5px;
        opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
        transition: opacity .2s;
    }
    .tip-input:hover {

        opacity: 1;
    }

    @media screen and ( min-width: 400px ){

        .tip-button-wrap {

            padding: 0px 15px;
        }
        .tip-button-wrap > button {

            width: 20%;
        }
    }
</style>